import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { selectIfSupport } from 'app/reducers/context.selectors';

/**
 * Полоса вкладок страницы меню. Сидит на пустом сегменте роута, поэтому видна на всех её
 * экранах, а URL не меняет — относительные навигации внутри menu-main продолжают работать
 * как раньше.
 */
@Component({
  selector: 'app-menu-tabs',
  templateUrl: './menu-tabs.component.html',
  styleUrls: ['./menu-tabs.component.scss'],
})
export class MenuTabsComponent {
  /** Special instructions правит поддержка; симметрично гарду на самом роуте. */
  public isSupport$: Observable<boolean> = this.store.select(selectIfSupport);

  constructor(private store: Store) {
  }
}
